import { get, post } from 'common/apiClient';
import React from 'react';
import { File } from 'vitest';

export type FilterPayload = {
  LANumber?: string | null;
  MerchantId?: string;
  OrderId?: string;
  PaymentDateFrom?: string;
  PaymentReferenceNo?: string;
  PaymentRequestId?: number | string | undefined | null;
  numValue?: number | string | undefined | null;
  To?: string;
  SourceApplicationName?: string;
  RequestPurpose?: string;
  PaymentPurpose?: string;
  Status?: string;
  RequestStatus?: string;
  Username?: string;
  pageNo?: number;
  pageSize?: number;
  IsExtract?: boolean;
  type?: number;
  sourceId?: string;
  userId?: string;
  roleId?: string;
  gatewayname?: string;
  PaymentId?: string;
};

export type OverdueFilter = {
  LoanNumber?: string;
  SourceApplicationName?: string;
  PageNo?: number;
  PageSize?: number;
  IsExtract?: boolean;
};

export type BulkUploadFilter = {
  bulkUploadFileId?: number;
  fileName?: string;
  status?: string;
  pageNo?: number;
  pageSize?: number;
  isExtract?: boolean;
};
export type BulkUploadPagedResponse = {
  data: BulkUploadPagedList;
};
export type BulkUploadFileResponse = {
  data: BulkUploadRow[];
};
export type BulkUploadPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  pageSize?: number;
  data: BulkUploadList[];
};
export type BulkUploadList = {
  key?: React.Key;
  bulkUploadRequestList: BulkUploadRequest[];
  bulkUploadFileId?: number;
  fileName: string;
  totalRecord?: number;
  totalSuccessRecord?: number;
  totalFailedRecord?: number;
  uploadStatus?: string;
  userEmailId?: string;
  partnerId?: number;
  sourceId?: string;
  createdBy?: string;
  createdDate?: string;
};
export type BulkUploadRequest = {
  key?: React.Key;
  bulkUploadFileId?: number;
  paymentRequestId?: number;
  loanNumber?: string;
  paymentPurpose?: string;
  amount?: number;
  accountName?: string;
  emailId?: string;
  mobileNo?: string;
  applicantType?: string;
  requestStatus?: string;
  requestErrorMessage?: string;
  createdDate?: string;
};

export type BulkUploadRow = {
  fileName?: string;
  bulkUploadFileId?: number;
  bulkUploadRequestId?: number;
  paymentRequestId?: number;
  loanNumber?: string;
  paymentPurpose?: string;
  amount?: number;
  accountName?: string;
  emailId?: string;
  mobileNo?: string;
  applicantType?: string;
  requestStatus?: string;
  requestErrorMessage?: string;
  createdDate?: string;
};

export type PaymentPagedResponse = {
  data: PaymentPagedList;
};
export type OverduePagedResponse = {
  data: OverduePagedList;
};

export type PaymentPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: PaymentListData[];
};

export type OverduePagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  pageSize?: number;
  data: OverdueList[];
};

export type PaymentListData = {
  RequestType: any;
  PaymentRequest: any;
  PAYMENTREQUESTID: any;
  LANUMBER: any;
  LOANTYPE: any;
  ACCOUNT_ID: any;
  SOURCEAPPLICATIONNAME: any;
  REQUESTPURPOSE: any;
  MODE: any;
  PAYMENTPURPOSE: any;
  MERCHANTID: any;
  AMOUNT: any;
  RequestStatus: any;
  NEW_STATUS: any;
  PAYMENTREF: any;
  REFTRANSACTION: any;
  OrderId: any;
  PaymentId: any;
  FUNDINGACCOUNT: any;
  BANKCODE: any;
  CURRENCY: any;
  FAVOURNAME: any;
  VERIFICATIONREASON: any;
  AGENTREJECTREMARKS: any;
  PAYMENTREQUESTDATETIME: any;
  PENNANTRECEIPTDATE: any;
  PENNANTRECEIPTNO: any;
  AUTH_CODE: any;
  BYAGENT: any;
  REMARKS: any;
  PAYMENTREQUESTERROR: any;
  PENNANTERRORDESC: any;
  WEBHOOKERROR: any;
  Action: any;
  IMPACTMODE: any;
  GATEWAYNAME: any;
};
export type AuditResponse = {
  data: AuditLog[];
};

export type RetryResponse = {
  data: string;
  message: String;
  responseCode: string;
  status: string;
};

export type RetryData = {
  message: String;
  responseCode: string;
  data: string;
  status: string;
};

export type AuditLog = {
  LANumber: string;
  Event: string;
  EventDateTime: string;
  ErrorDescription: string;
  JsonFormate: string;
  JsonResult: string;
};

export type CustomerModel = {
  ApplicantType: string | undefined;
  CustomerName: string;
  MobileNumber: string;
  EmailId: string;
  LoanBranch: string;
  CIFId: string;
  LoanType: string;
  key: React.Key;
  loanKey: React.Key;
};

export type OverdueList = {
  customers: CustomerModel[];
  LastLinkStatus: string;
  LastLinkCreated: Date;
  AllowedAmount: number;
  LoanBranch: string;
  CIFId: string;
  LoanType: string;
  key: React.Key;
  LoanNumber: string;
  EmiSiPiAmt: number;
  CurrMonthInst: number;
  BounceCharge: number;
  PenalCharge: number;
  TotalAmount: number;
  CustomerName: string;
  MobileNumber: string;
  EmailId: string;
  ApplicantType: string;
  isAppSelected?: boolean;
};

export type OverdueXLList = {
  // children: CustomerModel[];
  LastLinkStatus: string;
  LastLinkCreated: Date;
  AllowedAmount: number;
  LoanBranch: string;
  CIFId: string;
  LoanType: string;
  key: React.Key;
  LoanNumber: string;
  EmiSiPiAmt: number;
  CurrMonthInst: number;
  BounceCharge: number;
  PenalCharge: number;
  TotalAmount: number;
  CustomerName: string;
  MobileNumber: string;
  EmailId: string;
  ApplicantType: string;
};

export type BulkStatus = {
  LoanNumber?: string;
  Message?: string;
  isSuccess?: boolean;
  isCompleted: boolean;
  batchId?: string;
  initiatedDate?: Date;
};

export type AuditPayload = {
  paymentRequestId: number;
  IsExtract: boolean;
};
export type SelectPayload = {
  SKey: string;
};
export type SelectResponse = {
  data: SelectList[];
};

export type SelectList = {
  SKey: string;
  SValue: string;
  SText: string;
};

export type FeeFilterPayload = {
  lANumber?: string;
  orderId?: string;
  requestPurpose?: string;
  paymentPurpose?: string;
  requestStatus?: string;
  fromDate?: Date;
  status?: string;
  toDate?: Date;
  sourceApplicationName?: string;
  merchantId?: string;
  paymentRefNo?: string;
  paymentRequestId?: number;
  createdBy?: string;
  paymentId?: string;
  gatewayName?: string;
  feeType?: string;
  pageNo?: number;
  pageSize?: number;
  isExtract?: boolean;
  userId?: string;
};

export type FeesDashboardListData = {
  PAYMENTREQUESTID: any;
  LANUMBER: any;
  LOANTYPE: any;
  ACCOUNT_ID: any;
  SOURCEAPPLICATIONNAME: any;
  REQUESTPURPOSE: any;
  MODE: any;
  PAYMENTPURPOSE: any;
  MERCHANTID: any;
  AMOUNT: any;
  RequestStatus: any;
  NEW_STATUS: any;
  PAYMENTREF: any;
  REFTRANSACTION: any;
  OrderId: any;
  SESSIONID: any;
  PaymentId: any;
  FUNDINGACCOUNT: any;
  BANKCODE: any;
  CURRENCY: any;
  FAVOURNAME: any;
  VERIFICATIONREASON: any;
  AGENTREJECTREMARKS: any;
  PAYMENTREQUESTDATETIME: any;
  PENNANTRECEIPTDATE: any;
  PENNANTRECEIPTNO: any;
  AUTH_CODE: any;
  BYAGENT: any;
  REMARKS: any;
  PAYMENTREQUESTERROR: any;
  PENNANTERRORDESC: any;
  WEBHOOKERROR: any;
  IMPACTMODE: any;
  GATEWAYNAME: any;
  Action: any;
  FeeAmount: number;
  FeeDescription: string;
  FeeCode: any;
  FeeType: string;
};
export type FeesDashboardPagedList = {
  data: {
    noOfRecords: number;
    currentPageIndex?: number;
    data: FeesDashboardListData[];
  };
};
export type FeesDashboardPagedResponse = {
  data: FeesDashboardPagedList;
};
export const getFeesPaymentList = (payload?: FeeFilterPayload) =>
  post<FeesDashboardPagedList>('/dashboardmodule/feesDashboard/getFeesDashboard', payload);

export const getPaymentList = (payload?: FilterPayload) =>
  post<PaymentPagedResponse>('/dashboardmodule/getPaymentDashboard', payload);
export const getAuditLog = (paymentRequestId: number, IsExtract: boolean) =>
  get<AuditResponse>(
    '/dashboardmodule/getAuditLog?paymentRequestId=' + paymentRequestId + '&isExtract=' + IsExtract
  );

export const getPaymentReport = (payload?: FilterPayload) =>
  post<File>('/dashboardmodule/downloadPaymentReport', payload);

export const getSelectList = (payload?: SelectPayload) =>
  post<SelectResponse>('/dashboardmodule/getSelectLists', payload);

export const getOverdueList = (payload?: OverdueFilter) =>
  post<OverduePagedResponse>('/dashboardmodule/getOverdueDashboard', payload);

export const getBulkUploadList = (payload?: BulkUploadFilter) =>
  post<BulkUploadPagedResponse>('/dashboardmodule/getBulkUploadDashboard', payload);

export const getBulkUploadFile = (payload?: BulkUploadFilter) =>
  post<BulkUploadFileResponse>('/dashboardmodule/getBulkUploadFile', payload);

export const retry = (paymentRequestId: number) =>
  get<RetryResponse>('/agentmodule/retry?requestId=' + paymentRequestId);

// function getSheetData(data: any[], header: string[]) {
//   var fields = Object.keys(data[0]);
//   var sheetData = data.map(function (row) {
//     return fields.map(function (fieldName) {
//       return row[fieldName] ? row[fieldName] : "";
//     });
//   });
//   sheetData.unshift(header);
//   return sheetData;
// }

// export const download = (data: any[]) => {

//   // let header = ["Name", "City"];

//   // XlsxPopulate.fromBlankAsync().then(async (workbook: { sheet: (arg0: number) => any; outputAsync: () => Promise<any>; }) => {
//   //   const sheet1 = workbook.sheet(0);
//   //   const sheetData = getSheetData(data, header);
//   //   const totalColumns = sheetData[0]?.length;

//   //   sheet1.cell("A1").value(sheetData);
//   //   const range = sheet1.usedRange();
//   //   const endColumn = String.fromCharCode(64 + Number(totalColumns));
//   //   sheet1.row(1).style("bold", true);
//   //   sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
//   //   range.style("border", true);
//   //   return workbook.outputAsync().then((res) => {
//   //     saveAs(res, "file.xlsx");
//   //   });
//   // });
// }
